// extracted by mini-css-extract-plugin
module.exports = {"container":"Service_container__vmedO","service_top":"Service_service_top__3C32O","service_wrap":"Service_service_wrap__30xB1"};